import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicCalendar from './PublicCalendar';
import api from '../api/axios';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);
  const [calendarKey, setCalendarKey] = useState(0);
  const [nuking, setNuking] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      setIsAuthenticated(true);
    } else {
      navigate('/admin/login');
    }
    setChecking(false);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  const handleNukeAllEvents = async () => {
    const ok = window.confirm(
      'This will permanently delete EVERY calendar event from the database.\n\n' +
        'This cannot be undone. Continue?'
    );
    if (!ok) return;
    const typed = window.prompt('Type DELETE ALL to confirm:');
    if (typed !== 'DELETE ALL') {
      if (typed !== null) window.alert('Confirmation text did not match. No events were deleted.');
      return;
    }
    setNuking(true);
    try {
      const { data } = await api.delete('/events/clear-all');
      window.alert(`Deleted ${data.deletedCount ?? 0} event(s).`);
      setCalendarKey((k) => k + 1);
    } catch (err) {
      window.alert(err.response?.data?.message || err.message || 'Failed to delete events');
    } finally {
      setNuking(false);
    }
  };

  if (checking) {
    return <div className="loading">Checking authentication...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="admin-dashboard">
      <header className="admin-header">
        <h1>Admin Dashboard</h1>
        <div className="header-buttons">
          <button onClick={() => navigate('/admin/analyze')} className="biba-chat-btn">Back to Analyze</button>
          <button
            type="button"
            onClick={handleNukeAllEvents}
            disabled={nuking}
            className="nuke-events-btn"
          >
            {nuking ? 'Deleting…' : 'Nuke ALL EVENTS'}
          </button>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </header>
      <div className="admin-calendar-wrapper">
        <PublicCalendar key={calendarKey} />
      </div>
    </div>
  );
};

export default AdminDashboard;









